import { ArrowRight } from "lucide-react";

export default function RelatedService() {
  return (
    <section
      className="py-16 md:py-20 border-t-4 border-black bg-zinc-50"
      data-testid="related-service-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Label */}
        <span className="font-mono text-xs uppercase tracking-widest text-zinc-500">
          Related Service
        </span>

        {/* Heading */}
        <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl uppercase mt-4 mb-6">
          Already spending on the project?
        </h2>

        {/* Copy */}
        <div className="space-y-4 mb-8">
          <p className="font-body text-zinc-600 leading-relaxed">
            Blackline focuses on construction cost engineering, estimating and tender assurance before and during procurement.
          </p>
          <p className="font-body text-zinc-600 leading-relaxed">
            If you want to reconcile supplier charges against agreed rates and actual project records, <span className="font-semibold text-zinc-800">MeterBack for Construction</span> reviews historical project spend for evidence-backed discrepancies.
          </p>
        </div>

        {/* CTA */}
        <a
          href="https://meterback.com/construction"
          className="inline-flex items-center gap-2 font-heading font-bold text-sm uppercase tracking-wider text-black hover:text-zinc-600 transition-colors group"
          data-testid="meterback-cta"
        >
          Explore MeterBack for Construction
          <ArrowRight 
            size={18} 
            className="group-hover:translate-x-1 transition-transform" 
          />
        </a>
      </div>
    </section>
  );
}
